const flashMessage = document.querySelector('.flash-message')

if (flashMessage) {
  const closeButton = flashMessage.querySelector('.fas.fa-times-circle.close')

  closeButton.addEventListener('click', () => {
    flashMessage.classList.add('hidden')
  })
}
